'use es6';

import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';
export const addCustomSectionToDndAreaFromInpageSidebar = message => {
  return {
    type: actionTypes.ADD_CUSTOM_SECTION_TO_DND_AREA_FROM_INPAGE_SIDEBAR,
    message
  };
};
export const addCustomLayoutToDndAreaFromInpageSidebar = message => {
  return {
    type: actionTypes.ADD_CUSTOM_LAYOUT_TO_DND_AREA_FROM_INPAGE_SIDEBAR,
    message
  };
};
export const addEmbedToDndAreaFromInpageSidebar = message => {
  return {
    type: actionTypes.ADD_EMBED_TO_DND_AREA_FROM_INPAGE_SIDEBAR,
    message
  };
};